import React from 'react';
import { handleAdminError } from './common/SharedFunctions';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        handleAdminError(error);
    }

    render() {
        return this.props.children;
    }
}
